import { render, staticRenderFns } from "./index.vue?vue&type=template&id=80629b5c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=80629b5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80629b5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80629b5c')) {
      api.createRecord('80629b5c', component.options)
    } else {
      api.reload('80629b5c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=80629b5c&scoped=true", function () {
      api.rerender('80629b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/autoCacheSwitch/index.vue"
export default component.exports